import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

export default function AdminUsers() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    username: '', business_name: '', business_type: 'Barbería',
    owner_name: '', phone: '', address: '', subscription_plan: 'Mensual', price: '',
  });

  const isOwnerType = (t) => t === 'Barbería Dueño' || t === 'Centro de Estética Dueña';
  const userTypeLabel = (u) => {
    if (u.user_type === 'employee') return { txt: 'Empleado', color: '#a855f7' };
    if (u.user_type === 'owner' || isOwnerType(u.business_type)) return { txt: 'Dueño', color: '#5de6c8' };
    return { txt: 'Regular', color: '#8a95a8' };
  };

  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!search.trim()) setFiltered(users);
    else setFiltered(users.filter(u => u.username.toLowerCase().includes(search.toLowerCase()) || u.business_name.toLowerCase().includes(search.toLowerCase()) || u.owner_name.toLowerCase().includes(search.toLowerCase())));
  }, [search, users]);

  const load = async () => {
    try { const r = await api.get('/business/users'); setUsers(r.data); } catch (e) { console.error(e); }
  };

  const openModal = (user) => {
    if (user) {
      setEditing(user);
      setForm({ username: user.username, business_name: user.business_name, business_type: user.business_type, owner_name: user.owner_name, phone: user.phone, address: user.address, subscription_plan: user.subscription_plan, price: user.price.toString() });
    } else {
      setEditing(null);
      setForm({ username: '', business_name: '', business_type: 'Barbería', owner_name: '', phone: '', address: '', subscription_plan: 'Mensual', price: '' });
    }
    setShowModal(true);
  };

  const save = async (e) => {
    e.preventDefault();
    if (!form.business_name || !form.owner_name || !form.price) { alert('Completa los campos obligatorios'); return; }
    setLoading(true);
    try {
      if (editing) {
        await api.put(`/business/users/${editing.id}`, { business_name: form.business_name, business_type: form.business_type, owner_name: form.owner_name, phone: form.phone, address: form.address, subscription_plan: form.subscription_plan, price: parseFloat(form.price) });
      } else {
        if (!form.username) { alert('El nombre de usuario es obligatorio'); setLoading(false); return; }
        const payload = { ...form, price: parseFloat(form.price) };
        if (isOwnerType(form.business_type)) payload.user_type = 'owner';
        await api.post('/business/users', payload);
      }
      setShowModal(false); load();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
    finally { setLoading(false); }
  };

  const toggleActive = async (user) => {
    try { await api.put(`/business/users/${user.id}`, { is_active: !user.is_active }); load(); } catch (e) { alert('Error'); }
  };

  const del = (user) => {
    if (!confirm(`¿Eliminar a ${user.business_name}?`)) return;
    api.delete(`/business/users/${user.id}`).then(load).catch(() => alert('Error'));
  };

  return (
    <>
      <div className="header" style={{ background: '#000' }}>
        <button className="icon-btn" onClick={() => navigate('/admin')}>←</button>
        <h1 className="header-title" style={{ flex: 1 }}>Usuarios</h1>
      </div>
      <div className="search-container" style={{ background: '#000' }}>
        <div style={{ display: 'flex', gap: '12px' }}>
          <div className="search-input-wrap" style={{ flex: 1 }}>
            <span className="search-icon">🔍</span>
            <input className="search-input" placeholder="Buscar usuario..." value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <button className="add-btn" onClick={() => openModal(null)}>+</button>
        </div>
      </div>
      <div className="content-scroll" style={{ background: '#000' }}>
        {filtered.map(u => {
          const tag = userTypeLabel(u);
          return (
          <div key={u.id} className="card-row" style={{ background: '#1a1a1a', border: '1px solid #333' }} data-testid={`admin-user-${u.username}`}>
            <div className="card-row-info">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <div className="card-row-title" style={{ color: '#fff' }}>{u.business_name}</div>
                <span style={{ fontSize: '0.65rem', fontWeight: 700, color: tag.color, border: `1px solid ${tag.color}`, padding: '2px 8px', borderRadius: 10, letterSpacing: 0.5, textTransform: 'uppercase' }}>{tag.txt}</span>
              </div>
              <div className="card-row-detail">Usuario: {u.username}</div>
              <div className="card-row-detail">Dueño: {u.owner_name}</div>
              <div className="card-row-detail">Tipo: {u.business_type}</div>
              <div className="card-row-detail">Plan: {u.subscription_plan} - ${u.price}</div>
              <div style={{ fontSize: '14px', fontWeight: '600', marginTop: '4px', color: u.is_active ? '#18cb96' : '#ff4444' }}>
                {u.is_active ? 'Activo' : 'Inactivo'}
              </div>
            </div>
            <div className="card-row-actions">
              <button className="icon-btn-sm" onClick={() => openModal(u)}>✏️</button>
              <button className="icon-btn-sm" style={{ color: u.is_active ? '#FFA500' : '#18cb96' }} onClick={() => toggleActive(u)}>
                {u.is_active ? '⏸️' : '▶️'}
              </button>
              <button className="icon-btn-sm danger" onClick={() => del(u)}>🗑️</button>
            </div>
          </div>
          );
        })}
        {users.length === 0 && <div className="empty-state"><span className="empty-icon">👥</span><p className="empty-text" style={{ color: '#999' }}>No hay usuarios</p></div>}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content modal-center" onClick={e => e.stopPropagation()} style={{ background: '#1a1a1a', border: '1px solid #333', maxHeight: '90vh' }}>
            <h3 className="modal-title" style={{ color: '#fff' }}>{editing ? 'Editar Usuario' : 'Nuevo Usuario'}</h3>
            <form onSubmit={save} style={{ overflowY: 'auto' }}>
              <div className="form-group"><label className="label" style={{ color: '#fff' }}>Nombre del Emprendimiento *</label><input className="input" value={form.business_name} onChange={e => setForm({...form, business_name: e.target.value})} required /></div>
              {!editing && <div className="form-group"><label className="label" style={{ color: '#fff' }}>Nombre de Usuario *</label><input className="input" value={form.username} onChange={e => setForm({...form, username: e.target.value})} required /></div>}
              <div className="form-group">
                <label className="label" style={{ color: '#fff' }}>Elegir Perfil</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {['Barbería', 'Centro de Estética', 'Barbería Dueño', 'Centro de Estética Dueña', 'Vendedor'].map(t => (
                    <button key={t} type="button" className={`freq-btn ${form.business_type === t ? 'active' : ''}`}
                      onClick={() => setForm({...form, business_type: t})}>{t}</button>
                  ))}
                </div>
              </div>
              <div className="form-group"><label className="label" style={{ color: '#fff' }}>Nombre del Dueño *</label><input className="input" value={form.owner_name} onChange={e => setForm({...form, owner_name: e.target.value})} required /></div>
              <div className="form-group"><label className="label" style={{ color: '#fff' }}>Teléfono</label><input className="input" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
              <div className="form-group"><label className="label" style={{ color: '#fff' }}>Dirección</label><input className="input" value={form.address} onChange={e => setForm({...form, address: e.target.value})} /></div>
              <div className="form-group">
                <label className="label" style={{ color: '#fff' }}>Plan de Suscripción</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {['Mensual', 'Anual'].map(p => (
                    <button key={p} type="button" className={`freq-btn ${form.subscription_plan === p ? 'active' : ''}`}
                      onClick={() => setForm({...form, subscription_plan: p})}>{p}</button>
                  ))}
                </div>
              </div>
              <div className="form-group"><label className="label" style={{ color: '#fff' }}>Precio *</label><input className="input" type="number" step="0.01" value={form.price} onChange={e => setForm({...form, price: e.target.value})} required /></div>
              <div className="modal-buttons">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={loading}>{loading ? 'Guardando...' : 'Guardar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
